/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { colors, borderRadius, transitions } from '../../styles/theme';

interface TagProps {
  label: string;
  color?: string;
  size?: 'sm' | 'md';
  onClick?: () => void;
}

const baseStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: ${borderRadius.full};
  transition: all ${transitions.fast};
`;

const sizeStyles = {
  sm: css`
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
  `,
  md: css`
    padding: 0.375rem 1rem;
    font-size: 0.875rem;
  `,
};

export default function Tag({
  label,
  color = colors.primary[500],
  size = 'sm',
  onClick,
}: TagProps) {
  const dynamicStyles = css`
    background: ${color}15;
    color: ${color};
    /* Açık zeminde okunabilirlik için metin rengi koyulaştırılır */
    color: color-mix(in srgb, ${color} 65%, black);
    border: 1px solid ${color}30;

    ${onClick && `
      cursor: pointer;

      &:hover {
        background: ${color}25;
        border-color: ${color}50;
      }
    `}
  `;

  return (
    <span
      css={[baseStyles, sizeStyles[size], dynamicStyles]}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {label}
    </span>
  );
}
